import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/recycling',
    name: 'recyclingModule',
    component: () => import('@/views/restricted/recycling-module/RecyclingModuleLayoutView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_RECYCLING_READ'],
      menuSelected: 'recycling'
    }
  }
]
